<template >
    <v-app dark>     
        <toolbar v-if="!isManeuverTracker()"></toolbar>            
         <router-view style="padding-top:64px; top:64px; min-height:100vh;"></router-view>
         <v-footer v-if="!isManeuverTracker()" padless dark>
            <v-col
            class="text-center"
            cols="12"
            >
            Code Copyrighted ©Pair'O'Dice Studio Inc. 2025
            </v-col>
  </v-footer>
    </v-app>
</template>
<script>

import toolbar from "./toolbar"
import {
  VApp,
  VCol,
  VFooter,
} from "vuetify/lib";
export default {
  components: {    
    VApp,        
    VCol,
    VFooter,    
    toolbar
  },
  methods:{
    isManeuverTracker(){
      return this.$route.path.includes("charactersheet");
    }
  }
}
</script>
<style>
.v-toolbar__content{
    padding-left: 0px;
    width:100%;
}
.button{
    margin:8px;
}
.btn_center{
    display:flex;
    justify-content: center;
    height:40px;
    align-items: center;
}
.background_bar{
    background: url('../assets/basic_bar_elonged.png');
    background-size: 105% 76px;
    background-repeat:no-repeat;
    background-position-y: center;
    background-position-x: center;
}
</style>